<template>
  <div id="default-container">
    <SimpleHeader v-if="showSimpleHeader" />
    <Header id="header" v-else/>
    <slot />
    <!-- <Footer /> -->
  </div>
</template>

<script setup>
  import Header from '@/components/layout/Header.vue';
  import SimpleHeader from '@/components/layout/SimpleHeader.vue';
  import { useRouter, useRoute } from 'vue-router';
  import { computed } from 'vue';
  const router = useRouter();
  const route = useRoute();
  const showSimpleHeader = computed(() => {
    const headerHiddenRoutes = [
      '/onboarding',
    ];
    return headerHiddenRoutes.includes(route.path);
  });

</script>

<style scoped>
#default-container {
  /* padding: 20px; */
  /* max-width: 1200px; */
  margin: 0 auto;
}
#header {
  margin-bottom: 0px;
}
</style>
